module.exports = __webpack_public_path__ + "static/dp-princip-5-8ad535343102085b7ae213f5e729afee.svg";